import React, { useState } from 'react';
import { AccordionBody, AccordionHeader, UncontrolledAccordion, Row, Col,AccordionItem } from 'reactstrap';
import dayjs from 'dayjs';
import SelectDropdown from "../common/SelectDropdown";
import { Skeleton } from "@mui/material";
import { updateAgendaItem } from '../../../api/casp/agenda';
import { toast } from "react-toastify";
import IconButton from "@mui/material/IconButton";
import EditIcon from "../../../assets/images/icons/edit-line.svg";
import DeleteIcon from '@mui/icons-material/Delete';
import SweetAlertComponent from './SweetAlertComponent';
import { ucFirst } from '../../../helpers/string_helper';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { withTranslation } from 'react-i18next';
import { Role } from '../../../constants/Role';
import { useSelector } from 'react-redux';
import { getDownloadableLink } from '../../../api/casp/document';

const AgendaItemAccordionComponent = ({ receivedAgenda, editAccordionReload, agendaListItem, ind, statusList, setAgendaListItem, children, refresh, toggleAgendaEditModal, t }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);    
    const toggleNew = () => setDropdownOpen((prevState) => !prevState);
     const { user } = useSelector((state) => ({
            user: state.Profile.user,
        }));

    const [openDeleteAgendaModal, setOpenDeleteAgendaModal] = useState({agendaId:''});
    const [openAccordionId, setOpenAccordionId] = useState(null);
    const [deleteAgendaDate, setDeleteAgendaDate] = useState(null);

    const toggleAgendaDeleteModal = (deleteAgendaId, date) => {
        setOpenDeleteAgendaModal({agendaId:deleteAgendaId });
        setDeleteAgendaDate(dayjs(date));
    };
    

    const cancelSweetAlert = ()=>{
        setOpenDeleteAgendaModal({agendaId:''})
    }

    async function updateItem(status, item) {
        try {
            if (status.id !== item.status.id) {
                await updateAgendaItem(item.id, {
                    agendaId: item.agendaId,
                    description: item.description,
                    statusId: status.id
                })

                setAgendaListItem((prevAgendas) => {
                    const agendaIndex = prevAgendas.findIndex((agenda) => parseInt(agenda.id) === parseInt(item.agendaId))
                    const itemIndex = prevAgendas[agendaIndex].agendaItems.findIndex((agItem) => parseInt(agItem.id) === parseInt(item.id))
                    prevAgendas[agendaIndex].agendaItems[itemIndex].status = statusList.find((st) => parseInt(st.id) === parseInt(status.id))

                    return [...prevAgendas]
                })
            }
        } catch (e) {
            toast.error(e.message)
        }
    }

    const handleDownload = async (documentId) => {
        try {
            const result = await getDownloadableLink(documentId);
            window.open(result.data.data, '_blank');
        } catch (error) {
            console.error('Error downloading document:', error);
        }
    };
    return (
        <React.Fragment>

            <UncontrolledAccordion stayOpen>
                <div className="mb-2" key={`${ind}-agenda-accordion-row`}>
                    {
                        agendaListItem.length > 0  ?
                            (
                                agendaListItem.map((agenda, agendaIndex) => (
                                    <div key={agenda.id + '-agenda-item-col'} className="">
                                        <AccordionItem
                                        key={agenda.id + '-agenda-item-main'}>
                                            <AccordionHeader
                                                className="test-primary shadow-none individual-agenda-item"
                                                targetId={String(agenda.id)}
                                                key={agenda.id + '-agenda-item-header'}
                                                onClick={() => {
                                                    if (openAccordionId === agenda.id) {
                                                        setOpenAccordionId(null); // Close the associated accordion
                                                    } else {
                                                        setOpenAccordionId(agenda.id); // Open the accordion   
                                                    }
                                                }}
                                            >
                                                <div className="double_accordion_header w-100">
                                                    {agendaIndex ===  0  &&
                                                    <div className="fourColumns inner_accordion_header" style={{ display: 'grid', alignItems: 'center'}}>
                                                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} title={agenda.name}>
                                                                {t("Course & Agenda Name")}
                                                        </div>
                                                            <div>{t("Cohort Name")}</div>
                                                            <div>{t("No. of Files")}</div>
                                                            {(user?.role?.name === Role.EPMO_OFFICER || user?.role?.name === Role.MENTOR) && <div>{t("Actions")}</div>}
                                                    </div> 
}
                                                    <div className="fourColumns w-100" style={{ display: 'grid', alignItems: 'center'}}>
                                                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} title={agenda.name}>
                                                            {agenda.name}
                                                        </div>
                                                        <div>{agenda?.portfolio?.name}</div>
                                                        <div>{agenda.agendaItems.length}</div>
                                                        
                                                        <div className='borderRightOnActions'>
                                                            {(user?.role?.name === Role.EPMO_OFFICER || user?.role?.name === Role.MENTOR) && 
                                                            <div className='newActionIcons roundedBadgeIcons me-3'>
                                                                <EditOutlinedIcon
                                                                    className="me-3"
                                                                    id="editButton" key={`edit-${agendaIndex}-id-${agenda.id}`} onClick={(e) => {       
                                                                        e.stopPropagation(); 
                                                                        toggleAgendaEditModal(agenda.id); 
                                                                        editAccordionReload(receivedAgenda);
                                                                    }} 
                                                                />
                                                                <DeleteOutlineOutlinedIcon id="deleteAgenda" key={`del-${agendaIndex}-id-${agenda.id}`} onClick={(e) =>{e.stopPropagation();  toggleAgendaDeleteModal(agenda.id, agenda.date)}} />
                                                            </div>
                                                            }
                                                        </div> 
                                                    </div> 
                                                </div>
                                            </AccordionHeader>
                                            <AccordionBody
                                                accordionId={String(agenda.id)}
                                                className='todoListAccordion px-2'
                                            >
                                            {agenda.agendaItems.map((item) => (
                                                <div className="fourColumns_for_body acc_body_listing w-100" key={item.id + '-agenda-item-single'}>
                                                    <div className="d-flex">
                                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="0.75" y="1.25" width="18.5" height="18.5" rx="2.25" stroke={item.status.color} stroke-width="1.5"/>
                                                            <rect x="5" y="5.5" width="10" height="10" rx="1" fill={item.status.color} />
                                                        </svg>
                                                        <p className="ms-2 mb-0 text-truncate" style={{width: '400px'}} title={item.description}> {item.description} </p>
                                                    </div>
                                                    <div>
                                                        {item.documents?.map((doc) => (
                                                        <div
                                                            key={doc.id}
                                                            onClick={() => handleDownload(doc.id)}
                                                            style={{
                                                            cursor: doc.name !== '-' ? 'pointer' : 'default',
                                                            color: doc.name !== '-' ? '#0077cc' : 'inherit',
                                                            marginBottom: '4px'
                                                            }}
                                                        >
                                                            {doc.name || '-'}
                                                        </div>
                                                        ))}
                                                    </div>
                                                    <div className='blank_element'>
                                                    </div>
                                                    <div className="statusChip py-1">
                                                            {/* <SelectDropdown
                                                                label={ucFirst(item.status.name)}
                                                                className={'py-1'}
                                                                style={{ color: item?.status?.color, fontSize: '12px', padding: '2px 6px', background: item?.status?.color ? item?.status?.color + '33'  :'#EBEDF533', border: 0, borderRadius: 0 }}
                                                                list={statusList}
                                                                emitSelectedValue={(newValue) => updateItem(newValue, item)}
                                                            /> */}
                                                    </div>
                                                    <div className='blank_element'></div>
                                                </div>
                                            ))}
                                        </AccordionBody>
                                        </AccordionItem>
                                    </div>
                                ))

                            ) : (
                                <Col md={12}>
                                    <Row>
                                        <Col md={12}>
                                            <Skeleton variant="rounded" className="p-2 m-2 h-75" ></Skeleton>
                                        </Col>
                                        <Col md={12}>
                                            <Skeleton variant="rounded" className="p-2 m-2 h-75" ></Skeleton>
                                        </Col>
                                        <Col md={12}>
                                            <Skeleton variant="rounded" className="p-2 m-2 h-75" ></Skeleton>
                                        </Col>
                                        <Col md={12}>
                                            <Skeleton variant="rounded" className="p-2 m-2 h-75" ></Skeleton>
                                        </Col>
                                    </Row>
                                </Col>
                            )
                    }
                    {
                        children
                    }
                </div>
            </UncontrolledAccordion> 
            {openDeleteAgendaModal.agendaId !=='' &&(
                <SweetAlertComponent
                openDeleteAgendaModal ={openDeleteAgendaModal}
                cancelSweetAlert ={cancelSweetAlert}
                refresh={refresh}
                deleteAgendaDate={deleteAgendaDate}
                />
            )} 
        </React.Fragment>
                    
    );
};

export default withTranslation()(AgendaItemAccordionComponent);
